import { FormattedMessage } from "@modules/locales"
import { ThemeCss } from "gatsby-interface"

const RefreshCmsAccountDataMessage = ({
  message,
  refetch,
}: {
  message: string
  refetch: () => void
}) =>
  refetch ? (
    <FormattedMessage<never, "a">
      message={message}
      tags={{
        a: function(content) {
          return (
            <button
              aria-label="Refresh CMS account data"
              type="button"
              css={linkStyledButtonCss}
              onClick={() => refetch()}
            >
              {content}
            </button>
          )
        },
      }}
    />
  ) : null

const linkStyledButtonCss: ThemeCss = theme => ({
  display: "inline-flex",
  alignItems: "center",
  textDecoration: "underline",
  color: theme.colors.purple[60],
  background: "transparent",
  outline: "none",
  border: "none",
  padding: 0,
  "&:hover": {
    cursor: "pointer",
  },
})

export default RefreshCmsAccountDataMessage
